import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductManualRecommendationActions, ProductManualRecommendationApiService } from '@product/data-access/v2';
import { catchError, map, Observable, of, switchMap } from 'rxjs';

@Injectable()
export class ProductManualRecommendationEffects {
  loadProductManualRecommendation$: Observable<
    | ProductManualRecommendationActions.ProductManualRecommendationLoadSuccess
    | ProductManualRecommendationActions.ProductManualRecommendationLoadFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductManualRecommendationActions.LOAD_PRODUCT_MANUAL_RECOMMENDATION),
      map((action: ProductManualRecommendationActions.ProductManualRecommendationLoad) => action.payload),
      switchMap((productCode) => {
        return this.productManualRecommendationApiService.getProductManualRecommendationData(productCode).pipe(
          map((res) => new ProductManualRecommendationActions.ProductManualRecommendationLoadSuccess(res)),
          catchError((error: unknown) =>
            of(new ProductManualRecommendationActions.ProductManualRecommendationLoadFail(error)),
          ),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private productManualRecommendationApiService: ProductManualRecommendationApiService,
  ) {}
}
